var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 0H0v4.069h4.069z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 4.069H0v4.069h4.069v-4.07zM4.069 8.138H0v4.069h4.069z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 12.207H0v4.069h4.069v-4.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 16.276H0v4.069h4.069v-4.07z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 20.345H0v4.069h4.069v-4.07z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 24.414H0v4.069h4.069v-4.07zm0 8.138H0v4.069h4.069zm0 32.551H0v4.07h4.069zm0 24.414H0v4.07h4.069z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 93.586H0v4.07h4.069z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 97.655H0v4.069h4.069zm0 4.069H0v4.069h4.069zm0 4.069H0v4.069h4.069z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M4.069 109.862H0v4.069h4.069zm0 4.069H0V118h4.069zM8.138 0h-4.07v4.069h4.07zm0 24.414h-4.07v4.069h4.07v-4.07zm0 28.483h-4.07v4.069h4.07zm0 8.138h-4.07v4.068h4.07zm0 8.137h-4.07v4.07h4.07zm0 20.345h-4.07v4.07h4.07z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M8.138 113.931h-4.07V118h4.07zM12.207 0h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M12.207 12.207h-4.07v4.069h4.07v-4.07z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M12.207 16.276h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07v-4.07zm0 16.276h-4.07v4.069h4.07zM12.207 44.759h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M12.207 56.965h-4.07v4.07h4.07z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M12.207 61.035h-4.07v4.068h4.07zm0 4.068h-4.07v4.07h4.07zm0 12.207h-4.07v4.07h4.07zm0 12.207h-4.07v4.07h4.07zm0 8.138h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 8.138h-4.07V118h4.07zM16.276 0h-4.069v4.069h4.069zm0 8.138h-4.069v4.069h4.069z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M16.276 12.207h-4.069v4.069h4.069v-4.07z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M16.276 16.276h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M16.276 36.62h-4.069v4.07h4.069zm0 16.277h-4.069v4.069h4.069z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M16.276 56.965h-4.069v4.07h4.069zm0 8.138h-4.069v4.07h4.069zm0 12.207h-4.069v4.07h4.069zm0 4.07h-4.069v4.068h4.069zm0 8.137h-4.069v4.07h4.069zm0 8.138h-4.069v4.069h4.069zm0 4.069h-4.069v4.069h4.069zm0 4.069h-4.069v4.069h4.069zm0 8.138h-4.069V118h4.069zM20.345 0h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M20.345 12.207h-4.07v4.069h4.07v-4.07z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M20.345 16.276h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M20.345 36.62h-4.07v4.07h4.07zM20.345 40.69h-4.07v4.069h4.07zM20.345 44.759h-4.07v4.069h4.07zM20.345 48.828h-4.07v4.069h4.07zm0 8.137h-4.07v4.07h4.07zm0 8.138h-4.07v4.07h4.07z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M20.345 69.172h-4.07v4.07h4.07zm0 8.138h-4.07v4.07h4.07zm0 4.07h-4.07v4.068h4.07zm0 8.137h-4.07v4.07h4.07zm0 8.138h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 8.138h-4.07V118h4.07zM24.414 0h-4.07v4.069h4.07zm0 24.414h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07zm0 12.207h-4.07v4.069h4.07z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M24.414 48.828h-4.07v4.069h4.07zm0 20.344h-4.07v4.07h4.07z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M24.414 73.241h-4.07v4.07h4.07zm0 16.276h-4.07v4.07h4.07zm0 24.414h-4.07V118h4.07zM28.483 0h-4.07v4.069h4.07z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 4.069h-4.07v4.069h4.07v-4.07zM28.483 8.138h-4.07v4.069h4.07z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 12.207h-4.07v4.069h4.07v-4.07z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 16.276h-4.07v4.069h4.07v-4.07z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 20.345h-4.07v4.069h4.07v-4.07z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 24.414h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07v-4.07zm0 8.137h-4.07v4.07h4.07zm0 8.138h-4.07v4.07h4.07zm0 8.138h-4.07v4.07h4.07zm0 8.139h-4.07v4.068h4.07zm0 8.137h-4.07v4.07h4.07z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 93.586h-4.07v4.07h4.07z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 97.655h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.483 109.862h-4.07v4.069h4.07zm0 4.069h-4.07V118h4.07zm4.069-81.379h-4.07v4.069h4.07v-4.07z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M32.552 36.62h-4.07v4.07h4.07zM32.552 40.69h-4.07v4.069h4.07zM32.552 44.759h-4.07v4.069h4.07zm0 16.276h-4.07v4.068h4.07zm0 4.068h-4.07v4.07h4.07z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M32.552 69.172h-4.07v4.07h4.07z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M32.552 73.241h-4.07v4.07h4.07zM36.62 0h-4.068v4.069h4.069V0z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M36.62 4.069h-4.068v4.069h4.069v-4.07z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M36.62 8.138h-4.068v4.069h4.069v-4.07zm0 8.138h-4.068v4.069h4.069v-4.07zm0 8.138h-4.068v4.069h4.069v-4.07zm0 8.138h-4.068v4.069h4.069v-4.07zm0 8.138h-4.068v4.069h4.069v-4.07z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M36.62 44.759h-4.068v4.069h4.069v-4.07zm0 8.138h-4.068v4.069h4.069v-4.07z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M36.62 56.965h-4.068v4.07h4.069v-4.07zm0 24.415h-4.068v4.068h4.069V81.38zm0 4.068h-4.068v4.07h4.069v-4.07z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M36.62 89.517h-4.068v4.07h4.069v-4.07z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M36.62 93.586h-4.068v4.07h4.069v-4.07z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M36.62 97.655h-4.068v4.069h4.069v-4.069zm0 4.069h-4.068v4.069h4.069v-4.069zm0 12.207h-4.068V118h4.069v-4.069zM40.69 0h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M40.69 12.207h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07v-4.07zm0 20.345h-4.07v4.069h4.07zm0 24.413h-4.07v4.07h4.07z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M40.69 69.172h-4.07v4.07h4.07zm0 16.276h-4.07v4.07h4.07zm0 8.138h-4.07v4.07h4.07z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M40.69 97.655h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M40.69 109.862h-4.07v4.069h4.07zm0 4.069h-4.07V118h4.07zM44.759 4.069h-4.07v4.069h4.07zm0 12.207h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07v-4.07z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M44.759 28.483h-4.07v4.069h4.07v-4.07zM44.759 32.552h-4.07v4.069h4.07z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M44.759 36.62h-4.07v4.07h4.07zM44.759 40.69h-4.07v4.069h4.07zM44.759 44.759h-4.07v4.069h4.07zm0 12.206h-4.07v4.07h4.07z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M44.759 61.035h-4.07v4.068h4.07zm0 4.068h-4.07v4.07h4.07zm0 24.414h-4.07v4.07h4.07zm0 12.207h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 4.069h-4.07V118h4.07zM48.828 0h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M48.828 12.207h-4.07v4.069h4.07v-4.07z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M48.828 16.276h-4.07v4.069h4.07v-4.07z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M48.828 20.345h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07v-4.07zM48.828 32.552h-4.07v4.069h4.07z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M48.828 36.62h-4.07v4.07h4.07zm0 8.139h-4.07v4.069h4.07zM48.828 48.828h-4.07v4.069h4.07zm0 12.207h-4.07v4.068h4.07zm0 12.206h-4.07v4.07h4.07zm0 8.139h-4.07v4.068h4.07zm0 12.206h-4.07v4.07h4.07z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M48.828 97.655h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07zm0 8.138h-4.07V118h4.07zM52.897 8.138h-4.07v4.069h4.07z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M52.897 12.207h-4.07v4.069h4.07v-4.07z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M52.897 16.276h-4.07v4.069h4.07v-4.07z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M52.897 20.345h-4.07v4.069h4.07v-4.07z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M52.897 24.414h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07zm0 8.138h-4.07v4.069h4.07zM52.897 44.759h-4.07v4.069h4.07zM52.897 48.828h-4.07v4.069h4.07z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M52.897 52.897h-4.07v4.069h4.07zm0 8.138h-4.07v4.068h4.07zm0 12.206h-4.07v4.07h4.07z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M52.897 77.31h-4.07v4.07h4.07zm0 4.07h-4.07v4.068h4.07zm0 4.068h-4.07v4.07h4.07zm0 16.276h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zm0 8.138h-4.07V118h4.07zM56.965 0h-4.069v4.069h4.07z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M56.965 4.069h-4.069v4.069h4.07v-4.07zM56.965 8.138h-4.069v4.069h4.07zm0 8.138h-4.069v4.069h4.07v-4.07z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M56.965 20.345h-4.069v4.069h4.07v-4.07zm0 12.207h-4.069v4.069h4.07zm0 16.276h-4.069v4.069h4.07zm0 12.207h-4.069v4.068h4.07zm0 12.206h-4.069v4.07h4.07z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M56.965 77.31h-4.069v4.07h4.07zm0 4.07h-4.069v4.068h4.07zm0 4.068h-4.069v4.07h4.07z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M56.965 89.517h-4.069v4.07h4.07z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M56.965 93.586h-4.069v4.07h4.07z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M56.965 97.655h-4.069v4.069h4.07zm0 8.138h-4.069v4.069h4.07z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M56.965 109.862h-4.069v4.069h4.07zm0 4.069h-4.069V118h4.07zM61.035 0h-4.07v4.069h4.07z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M61.035 4.069h-4.07v4.069h4.07v-4.07zM61.035 8.138h-4.07v4.069h4.07z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M61.035 12.207h-4.07v4.069h4.07v-4.07zm0 8.138h-4.07v4.069h4.07v-4.07z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M61.035 24.414h-4.07v4.069h4.07v-4.07z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M61.035 28.483h-4.07v4.069h4.07v-4.07zM61.035 32.552h-4.07v4.069h4.07z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M61.035 36.62h-4.07v4.07h4.07zM61.035 40.69h-4.07v4.069h4.07zM61.035 44.759h-4.07v4.069h4.07zM61.035 48.828h-4.07v4.069h4.07zm0 8.137h-4.07v4.07h4.07z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M61.035 61.035h-4.07v4.068h4.07zm0 12.206h-4.07v4.07h4.07zm0 28.483h-4.07v4.069h4.07zm0 4.069h-4.07v4.069h4.07zM65.103 0h-4.069v4.069h4.07z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M65.103 4.069h-4.069v4.069h4.07v-4.07zm0 8.138h-4.069v4.069h4.07v-4.07z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M65.103 16.276h-4.069v4.069h4.07v-4.07zm0 16.276h-4.069v4.069h4.07zm0 12.207h-4.069v4.069h4.07zm0 12.206h-4.069v4.07h4.07zm0 8.138h-4.069v4.07h4.07zm0 12.207h-4.069v4.07h4.07zm0 12.207h-4.069v4.07h4.07zm0 8.138h-4.069v4.069h4.07zm0 12.207h-4.069v4.069h4.07zm4.069-85.448h-4.069v4.069h4.07v-4.07z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M69.172 32.552h-4.069v4.069h4.07v-4.07zm0 28.483h-4.069v4.068h4.07v-4.068zm0 12.206h-4.069v4.07h4.07v-4.07z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M69.172 77.31h-4.069v4.07h4.07v-4.07zm0 8.138h-4.069v4.07h4.07v-4.07z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M69.172 89.517h-4.069v4.07h4.07v-4.07z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M69.172 93.586h-4.069v4.07h4.07v-4.07z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M69.172 97.655h-4.069v4.069h4.07v-4.069zm0 4.069h-4.069v4.069h4.07v-4.069zm0 4.069h-4.069v4.069h4.07v-4.069zm0 8.138h-4.069V118h4.07v-4.069zM73.241 4.069h-4.069v4.069h4.07zm0 8.138h-4.069v4.069h4.07z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M73.241 16.276h-4.069v4.069h4.07v-4.07zm0 16.276h-4.069v4.069h4.07z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M73.241 36.62h-4.069v4.07h4.07zm0 8.139h-4.069v4.069h4.07zm0 8.138h-4.069v4.069h4.07z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M73.241 56.965h-4.069v4.07h4.07zm0 12.207h-4.069v4.07h4.07z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M73.241 73.241h-4.069v4.07h4.07zm0 12.207h-4.069v4.07h4.07zm0 12.207h-4.069v4.069h4.07zm0 16.276h-4.069V118h4.07zM77.31 0h-4.069v4.069h4.07V0zm0 20.345h-4.069v4.069h4.07v-4.07z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M77.31 24.414h-4.069v4.069h4.07v-4.07z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M77.31 28.483h-4.069v4.069h4.07v-4.07z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M77.31 32.552h-4.069v4.069h4.07v-4.07z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M77.31 36.62h-4.069v4.07h4.07v-4.07zm0 8.139h-4.069v4.069h4.07v-4.07zm0 8.138h-4.069v4.069h4.07v-4.07zm0 8.138h-4.069v4.068h4.07v-4.068zm0 20.345h-4.069v4.068h4.07V81.38zm0 4.068h-4.069v4.07h4.07v-4.07zm0 8.138h-4.069v4.07h4.07v-4.07zm0 8.138h-4.069v4.069h4.07v-4.069zm0 4.069h-4.069v4.069h4.07v-4.069zm0 8.138h-4.069V118h4.07v-4.069zM81.379 4.069H77.31v4.069h4.069zM81.379 8.138H77.31v4.069h4.069zm0 8.138H77.31v4.069h4.069v-4.07zm0 12.207H77.31v4.069h4.069v-4.07z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M81.379 32.552H77.31v4.069h4.069z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M81.379 36.62H77.31v4.07h4.069zm0 8.139H77.31v4.069h4.069zM81.379 48.828H77.31v4.069h4.069zm0 8.137H77.31v4.07h4.069zm0 12.207H77.31v4.07h4.069z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M81.379 73.241H77.31v4.07h4.069zm0 16.276H77.31v4.07h4.069z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M81.379 93.586H77.31v4.07h4.069z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M81.379 97.655H77.31v4.069h4.069zm0 16.276H77.31V118h4.069zM85.448 4.069H81.38v4.069h4.07v-4.07z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 8.138H81.38v4.069h4.07v-4.07zm0 12.207H81.38v4.069h4.07v-4.07z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 24.414H81.38v4.069h4.07v-4.07z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 28.483H81.38v4.069h4.07v-4.07zm0 12.207H81.38v4.069h4.07v-4.07zm0 16.275H81.38v4.07h4.07v-4.07zm0 8.138H81.38v4.07h4.07v-4.07z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 69.172H81.38v4.07h4.07v-4.07z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 73.241H81.38v4.07h4.07v-4.07zm0 8.139H81.38v4.068h4.07V81.38zm0 4.068H81.38v4.07h4.07v-4.07z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 89.517H81.38v4.07h4.07v-4.07z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 93.586H81.38v4.07h4.07v-4.07z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M85.448 97.655H81.38v4.069h4.07v-4.069zm0 4.069H81.38v4.069h4.07v-4.069zm0 12.207H81.38V118h4.07v-4.069zm4.069-81.379h-4.069v4.069h4.07v-4.07z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M89.517 36.62h-4.069v4.07h4.07v-4.07z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M89.517 40.69h-4.069v4.069h4.07v-4.07z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M89.517 44.759h-4.069v4.069h4.07v-4.07zm0 8.138h-4.069v4.069h4.07v-4.07z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M89.517 56.965h-4.069v4.07h4.07v-4.07zm0 8.138h-4.069v4.07h4.07v-4.07zm0 12.207h-4.069v4.07h4.07v-4.07zm0 4.07h-4.069v4.068h4.07V81.38zm0 16.275h-4.069v4.069h4.07v-4.069zm0 4.069h-4.069v4.069h4.07v-4.069zm0 4.069h-4.069v4.069h4.07v-4.069z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M89.517 109.862h-4.069v4.069h4.07v-4.069zM93.586 0h-4.069v4.069h4.07z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M93.586 4.069h-4.069v4.069h4.07v-4.07zM93.586 8.138h-4.069v4.069h4.07z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M93.586 12.207h-4.069v4.069h4.07v-4.07z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M93.586 16.276h-4.069v4.069h4.07v-4.07z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M93.586 20.345h-4.069v4.069h4.07v-4.07z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M93.586 24.414h-4.069v4.069h4.07v-4.07zm0 20.345h-4.069v4.069h4.07zM93.586 48.828h-4.069v4.069h4.07z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M93.586 52.897h-4.069v4.069h4.07z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M93.586 56.965h-4.069v4.07h4.07zm0 24.415h-4.069v4.068h4.07zm0 8.137h-4.069v4.07h4.07zm0 8.138h-4.069v4.069h4.07zm0 12.207h-4.069v4.069h4.07zm0 4.069h-4.069V118h4.07zM97.655 0h-4.069v4.069h4.07V0zm0 24.414h-4.069v4.069h4.07v-4.07zm0 12.206h-4.069v4.07h4.07v-4.07z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M97.655 40.69h-4.069v4.069h4.07v-4.07zm0 8.138h-4.069v4.069h4.07v-4.07zm0 8.137h-4.069v4.07h4.07v-4.07zm0 4.07h-4.069v4.068h4.07v-4.068zm0 16.275h-4.069v4.07h4.07v-4.07zm0 4.07h-4.069v4.068h4.07V81.38zm0 16.275h-4.069v4.069h4.07v-4.069zm0 4.069h-4.069v4.069h4.07v-4.069zm0 4.069h-4.069v4.069h4.07v-4.069z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M97.655 109.862h-4.069v4.069h4.07v-4.069zM101.724 0h-4.069v4.069h4.069zm0 8.138h-4.069v4.069h4.069z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M101.724 12.207h-4.069v4.069h4.069v-4.07z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M101.724 16.276h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M101.724 36.62h-4.069v4.07h4.069zm0 16.277h-4.069v4.069h4.069zm0 8.138h-4.069v4.068h4.069zm0 8.137h-4.069v4.07h4.069zm0 8.138h-4.069v4.07h4.069zm0 4.07h-4.069v4.068h4.069zm0 4.068h-4.069v4.07h4.069z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M101.724 89.517h-4.069v4.07h4.069z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M101.724 93.586h-4.069v4.07h4.069z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M101.724 97.655h-4.069v4.069h4.069zm0 8.138h-4.069v4.069h4.069zm0 8.138h-4.069V118h4.069zM105.793 0h-4.069v4.069h4.069zm0 8.138h-4.069v4.069h4.069z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M105.793 12.207h-4.069v4.069h4.069v-4.07z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M105.793 16.276h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069v-4.07zm0 20.345h-4.069v4.069h4.069zm0 8.138h-4.069v4.069h4.069zm0 12.206h-4.069v4.07h4.069zm0 8.138h-4.069v4.07h4.069z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M105.793 77.31h-4.069v4.07h4.069zm0 4.07h-4.069v4.068h4.069zm0 4.068h-4.069v4.07h4.069z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M105.793 89.517h-4.069v4.07h4.069zm0 8.138h-4.069v4.069h4.069zm0 12.207h-4.069v4.069h4.069zm0 4.069h-4.069V118h4.069zM109.862 0h-4.069v4.069h4.069zm0 8.138h-4.069v4.069h4.069z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M109.862 12.207h-4.069v4.069h4.069v-4.07z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M109.862 16.276h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M109.862 36.62h-4.069v4.07h4.069zM109.862 40.69h-4.069v4.069h4.069zm0 12.207h-4.069v4.069h4.069z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M109.862 56.965h-4.069v4.07h4.069z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M109.862 61.035h-4.069v4.068h4.069zm0 8.137h-4.069v4.07h4.069zm0 8.138h-4.069v4.07h4.069zm0 4.07h-4.069v4.068h4.069zm0 24.413h-4.069v4.069h4.069zm0 4.069h-4.069v4.069h4.069zM113.931 0h-4.069v4.069h4.069zm0 24.414h-4.069v4.069h4.069v-4.07zm0 8.138h-4.069v4.069h4.069z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M113.931 36.62h-4.069v4.07h4.069zm0 16.277h-4.069v4.069h4.069zm0 16.275h-4.069v4.07h4.069zm0 12.208h-4.069v4.068h4.069zm0 12.206h-4.069v4.07h4.069z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M113.931 97.655h-4.069v4.069h4.069zm0 4.069h-4.069v4.069h4.069zm0 4.069h-4.069v4.069h4.069zM118 0h-4.069v4.069H118z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 4.069h-4.069v4.069H118v-4.07zM118 8.138h-4.069v4.069H118z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 12.207h-4.069v4.069H118v-4.07z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 16.276h-4.069v4.069H118v-4.07z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 20.345h-4.069v4.069H118v-4.07z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 24.414h-4.069v4.069H118v-4.07zm0 8.138h-4.069v4.069H118zm0 12.207h-4.069v4.069H118zM118 48.828h-4.069v4.069H118z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 52.897h-4.069v4.069H118z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 56.965h-4.069v4.07H118z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 61.035h-4.069v4.068H118zm0 12.206h-4.069v4.07H118zm0 32.552h-4.069v4.069H118z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M118 109.862h-4.069v4.069H118z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.cad90ed54ac8183f36083dfe0daddd70.svg";
export { ForwardRef as ReactComponent };